import type {Action} from '@/redux/typesNew';
import type {Inventory} from '@/redux/v1/models';

export const FETCH_INVENTORY = 'v1/hotels/inventory/FETCH_INVENTORY';

type RequestMeta = {
  requestId: string;
};

// @TODO abstract via redux/types
export type FetchInventoryPending = Action<''> & {
  meta: RequestMeta;
};
export type FetchInventorySuccess = Action<''> & {
  data: {
    inventoryUnfiltered: Inventory;
    inventoryFiltered: Inventory;
    translations: Record<string, string>;
  };
  meta: RequestMeta;
};
export type FetchInventoryError = Action<''> & {
  error: unknown;
  meta: RequestMeta;
};
